import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';
import React from 'react';
import mediatek from '../../../assets/v2/CustomHardware/mediatek-device.png';
import { navigate, graphql, StaticQuery } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Image from 'gatsby-image';
import { Title } from '../HomePage/HomepageSectionOne';

const ImgItem = styled(Image)`
  width: 100%;
  margin-left: -10%;
  justify-self: right;
  @media (max-width: 768px) {
    margin-top: 0rem;
    width: calc(100%);
    margin-left: 0rem;
  }
  @media (max-width: 520px) {
    height: 20rem;
    display: none;
  }
`;

const ImgItemMobile = styled(LazyLoadImage)`
  display: none;
  @media (max-width: 520px) {
    width: calc(100% + 2rem);
    margin-left: -1rem;
    display: unset;
  }
`;

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 6rem !important;
  background-size: contain;
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 8rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(24, 1fr);
  display: grid;
  padding-left: 8rem;
  @media (max-width: 800px) {
    padding-left: 0;
  }
`;

const SectionOneTitle = styled(Title)`
  line-height: 1.21;
  color: #4a5376;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const GridLeft = styled.div`
  grid-column: span 12;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 24;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridRight = styled.div`
  grid-column: span 12;
  display: grid;
  align-content: center;
  @media (max-width: 768px) {
    grid-column: span 24;
  }
  @media (max-width: 520px) {
    padding-top: 1rem;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #6a718c;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
  }
`;
const BlueButtonWrapper = styled.div`
  margin-left: -10px;
  margin-top: 24px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

export default () => (
  <div style={{ zIndex: 1, position: 'relative', background: '#ffffff' }}>
    <SectionOne>
      <SectionItemContainer>
        <GridLeft>
          <SectionOneTitle>MediaTek Rich IOT Platform</SectionOneTitle>
          <HeroSubTitle style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
            MediaTek's Rich IoT program features a series of AI-supported
            chipset platforms that enable companies to innovate and develop
            intelligent devices in the market. As the market leader of chips for
            voice assistant devices (VAD), MediaTek work with the world’s most
            well-known brands to power intelligent devices. This product helps
            enterprises, startups, emerging brands and leading OEMs in diverse
            markets to design a wide range of IoT devices with edge-AI
            capabilities, new user experiences and addressing new market
            opportunities.
          </HeroSubTitle>
        </GridLeft>
        <GridRight>
          <StaticQuery
            query={graphql`
              query {
                file(
                  relativePath: { eq: "v2/CustomHardware/rich-mediatek.png" }
                ) {
                  childImageSharp {
                    fluid(quality: 95) {
                      aspectRatio
                      src
                      srcSet
                      sizes
                      srcWebp
                      srcSetWebp
                    }
                  }
                }
              }
            `}
            render={(data: any) => (
              <ImgItem
                loading="lazy"
                fluid={data.file.childImageSharp.fluid}
                alt="Esper Andi"
              />
            )}
          />

          <ImgItemMobile alt="Esper Andi" src={mediatek} />
        </GridRight>
      </SectionItemContainer>
    </SectionOne>
  </div>
);
